import { AsyncAppThunkAction } from "./redux-store";
import * as cargoViewActions from "./ducks/data/cargo-views";
import * as routeViewModelActions from "./ducks/data/route-views";
import * as upcomingPageActions from "./ducks/app/upcoming-page";
import { recheckOpenCargo } from "./ducks/app/cargo-dialog";
import { markResync } from "./request-timing";

// Reconnecting after a dropped connection may have missed events
// (cargo created/moved, route reassignments, etc.) — resync the
// board views wholesale rather than relying on the missed messages.
export const resyncAfterReconnect =
  (): AsyncAppThunkAction => async (dispatch) => {
    markResync();
    try {
      await dispatch(cargoViewActions.loadUndispatchedCargoViews()).unwrap();
    } catch {
      // The thunk has already reported it (or deliberately not, for a 401).
      // Whatever failed it, most often a session that expired while the
      // laptop slept, would fail the other reloads too, so skip them.
      return;
    }
    dispatch(routeViewModelActions.resyncRouteViewModelsAfterReconnect());
    dispatch(upcomingPageActions.refresh());
    // An open cargo dialog may have missed its cargo's cargo-view.deleted.
    await dispatch(recheckOpenCargo());
  };
